<template>
  <div class="">
    <el-dialog
      @open="open"
      :title="isReUpload ? $t('product.UploadImgs.886333-0') : $t('product.UploadImgs.886333-1')"
      :visible.sync="show"
      :modal-append-to-body="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="44%"
      @close="close"
    >
      <div style="margin-bottom: 10px">
        <el-upload
          v-loading="loading"
          class="upload-demo"
          :action="uploadAction"
          :headers="uploadHeaders"
          list-type="picture-card"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
          :multiple="true"
          accept="image/*"
          :file-list="fileList"
          :limit="30"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <el-alert style="margin-top: 10px" :closable="false" type="warning" :show-icon="false">
        <div>{{ $t("product.UploadImgs.027853-0") }}</div>
        <div>
          {{ $t("product.UploadImgs.027853-1") }}({{ $t("product.UploadImgs.027853-2") }}){{
            $t("product.UploadImgs.027853-3")
          }}
        </div>
        <div>{{ $t("product.UploadImgs.027853-4") }}</div>
        <div style="margin-top: 5px">
          {{ $t("product.UploadImgs.027853-5") }}
        </div>
        <div>{{ $t("product.UploadImgs.027853-6") }}</div>
        <div>{{ $t("product.UploadImgs.027853-7") }}</div>
        <div>
          {{ $t("product.UploadImgs.027853-8") }}
        </div>
        <div>{{ $t("product.UploadImgs.027853-9") }}</div>
        <span class="detail_jc" @click="showJc = true">{{ $t("product.UploadImgs.027853-10") }}</span>
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">{{ $t("product.UploadImgs.027853-11") }}</el-button>
        <el-button size="small" type="primary" @click="handlerSubmit">{{
          $t("product.UploadImgs.027853-12")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('product.UploadImgs.027853-10')"
      :visible.sync="showJc"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="620px"
      @close="closeJc"
      class="tutorial_dialog"
    >
      <div class="tutorial_wrap">
        <div class="tutorial_tit">{{ $t("product.UploadImgs.027853-13") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-14") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-15") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-16") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-17") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-18") }}</div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026535310-d2490dac-e9d0-4e14-a9b6-7f6e303dcc51.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026768571-1e3a9ac9-70bb-4821-acf0-dbadc9e34bb1.png" alt="" />
        </div>
        <div class="tutorial_content">
          {{ $t("product.UploadImgs.027853-19") }} ({{ $t("product.UploadImgs.027853-20") }})
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026817155-b002f8d6-a2cf-4bb3-8932-e8c099b12afe.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026839199-e9ea2fa0-5194-404f-90b6-01eccfec4f3a.png" alt="" />
        </div>

        <div class="tutorial_tit">{{ $t("product.UploadImgs.027853-21") }}</div>
        <div class="tutorial_content">{{ $t("product.UploadImgs.027853-22") }}</div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026916060-a837a709-e157-4a09-b38a-405b1cf79176.png" alt="" />
        </div>
        <div>
          {{ $t("product.UploadImgs.027853-23") }}
          {{ $t("product.UploadImgs.027853-24") }}
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026954809-585cbbbb-049d-4094-a833-7a088bd5d7ea.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721026985692-d6559349-64ce-4cba-aa12-bc0ccaf9368d.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027018163-2025e98a-f58f-4aff-8bdc-35ae7adc79eb.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027051718-3198d208-d019-41be-907d-f53d2ef47f32.png" alt="" />
        </div>
        <div>
          {{ $t("product.UploadImgs.027853-25") }}
          {{ $t("product.UploadImgs.027853-26") }}
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027085360-4aafee55-b639-4f50-b8d2-2a4d991eec83.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027103804-1f17d6e2-dd68-47e3-8c88-4af7255354cc.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027140920-626ad14d-7631-4e6b-aebc-525a5bb414b1.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027161411-0cc8dc70-cb58-461d-82f9-945f7f59e4cb.png" alt="" />
        </div>

        <div class="tutorial_tit" style="margin-top: 20px">
          {{ $t("product.UploadImgs.027853-27") }}({{ $t("product.UploadImgs.027853-28") }}){{ $t("product.UploadImgs.027853-29") }}
        </div>
        <div>
          {{ $t("product.UploadImgs.027853-30") }}
          {{ $t("product.UploadImgs.027853-31") }}
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027322868-9508e887-5c9d-420d-aa74-d617f4a5c815.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027335356-a7cf92e4-e05b-4aef-8657-9c12223502d4.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027345419-29f7adc9-e27f-4195-9ae5-e73a63872c1a.png" alt="" />
        </div>
        <div>
          {{ $t("product.UploadImgs.027853-32") }}
          {{ $t("product.UploadImgs.027853-33") }}
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027364663-1d673057-a206-4b7d-8b93-024ce50d035f.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027376566-634781fb-e2a9-4c27-aa96-12de46854869.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027386648-efac6350-0160-492d-b773-b8679619c301.png" alt="" />
        </div>
        <div>
          {{ $t("product.UploadImgs.027853-34") }}
          {{ $t("product.UploadImgs.027853-31") }}
        </div>
        <div>
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027407712-cda3fedf-cfa8-4862-9129-090e7a81fab3.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027421161-5f96951a-274e-49f2-a47d-6271ba29863b.png" alt="" />
          <img src="https://oss.reyeah.com/reyeah/20240715/1721027431454-75b417b5-4d33-49df-b519-8a1a7540eb31.png" alt="" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeJc" size="small">{{ $t("product.UploadImgs.027853-36") }}</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showPhotoList" :on-close="closeViewer" :zIndex="9999" :url-list="showBigImgList" />
  </div>
</template>

<script>
import config from "@/http/config";
import { mapGetters } from "vuex";

export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer")
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    isReUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showJc: false,
      showBigImgList: ["https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"],
      showPhotoList: false,
      fileList: []
    };
  },
  computed: {
    ...mapGetters(["token"]),
    uploadAction() {
      return config.baseUrl + this.$url.Upload.product;
    },
    uploadHeaders() {
      return {
        token: this.token
      };
    }
  },
  watch: {},
  methods: {
    open() {
      this.fileList = [];
      if (this.isReUpload) {
        this.getImgs();
      }
    },
    async getImgs() {
      const goodsId = this.product && (this.product.goodsId || this.product.id);
      if (!goodsId) {
        this.$message.warning(this.$t("common.noData"));
        return;
      }

      this.loading = true;
      try {
        const res = await this.$api.request(this.$url.OpenDoor.getSkuImageList, this.$method.get, {
          goodsId
        });
        if (res.code === 0) {
          const records = Array.isArray(res.data && res.data.records) ? res.data.records : [];
          this.fileList = records.map(item => {
            return {
              id: item.id,
              url: item.image
            };
          });
        } else {
          this.$message.warning(res.msg);
        }
      } catch (error) {
        this.$message.error(this.$t("product.UploadImgs.027853-45"));
        console.log("error:", error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("close");
    },
    closeViewer() {
      this.showPhotoList = false;
    },
    closeJc() {
      this.showJc = false;
    },
    async handlerSubmit() {
      if (this.fileList.length < 6) {
        this.$message.warning(this.$t("uploadLeastSixPhotos"));
        return;
      }
      const imageUrls = this.fileList.map(item => ({ image: item.url }));
      for (let i = 0; i < imageUrls.length; i++) {
        if (imageUrls[i].image.indexOf("http") !== 0) {
          this.$message.warning(this.$t("product.UploadImgs.027853-47"));
          return;
        }
      }

      try {
        const res = await this.$api.request(this.$url.OpenDoor.saveOrEditSkuImage, this.$method.post, {
          goodsId: this.product.goodsId || this.product.id,
          imageUrls: imageUrls,
          imageType: 1
        });
        if (res.code === 0) {
          this.$message.success(this.$t("product.UploadImgs.027853-48"));
          this.$emit("refresh");
        } else {
          this.$message.warning(res.msg);
        }
      } catch (error) {
        this.$message.warning(this.$t("product.UploadImgs.027853-49"));
        console.log("error:" + error);
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 0) {
        const imageUrl = response.data;
        file.url = imageUrl;
        this.fileList = fileList;
      } else {
        this.$message.error(response.msg);
        const index = fileList.indexOf(file);
        if (index !== -1) {
          fileList.splice(index, 1);
        }
        this.fileList = fileList;
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleError(err, file, fileList) {
      this.$message.error(this.$t("product.UploadImgs.027853-50"));
      const index = fileList.indexOf(file);
      if (index !== -1) {
        fileList.splice(index, 1);
      }
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning(this.$t("product.UploadImgs.027853-51"));
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  height: auto !important;
}
.detail_jc {
  margin-top: 5px;
  color: #00f;
  cursor: pointer;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  margin-right: 10px !important;
  margin-bottom: 10px !important;
}
::v-deep .upload-demo .el-upload-list__item img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.tutorial_dialog {
  .tutorial_wrap {
    height: 80vh;
    overflow-y: scroll;

    img {
      object-fit: cover;
      width: 150px;
      height: 150px;
      font-size: 0;
      margin: 5px 3px;
      box-shadow: 3px 3px 5px #ccc;
      border-radius: 5px;
      overflow: hidden;
    }

    .tutorial_tit {
      font-size: 16px;
      font-weight: bolder;
    }
  }
}
</style>
